import SectionHeading from './SectionHeading'
import SectionSubText from './SectionSubText'

export default function OlmEdge() {
    const perks = [
        'Access to exclusive investor-tested templates',
        '15% OFF your first campaign (Code: SWITCH15)',
        'A free strategy session tailored to your market',
        '1,500 free leads to jumpstart your campaigns',
        'Real coaching + real tracking so you can scale confidently',
    ]

    return (
        <section className="py-10 md:py-14">
            <div className="relative overflow-hidden rounded-3xl md:rounded-[56px] bg-light-yellow-gradient">
                <div className="relative px-5 md:px-10 py-12 md:py-16">
                    {/* Headings */}
                    <div className="max-w-3xl mx-auto text-center">
                        <SectionHeading>
                            <span className="text-olm-new-black">
                                The OLM Edge: Why Choose Us
                            </span>
                        </SectionHeading>
                        <SectionSubText>
                            When you choose OLM, you don’t just get mail. You
                            get:
                        </SectionSubText>
                    </div>

                    {/* Content */}
                    <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center max-w-6xl mx-auto">
                        {/* Left: Perks list */}
                        <ul className="space-y-6 md:space-y-8 text-olm-new-black">
                            {perks.map((item) => (
                                <li
                                    key={item}
                                    className="flex items-start gap-3">
                                    <img
                                        src="/assets/better-direct-mail/check-icon.svg"
                                        alt=""
                                        className="mt-1 h-5 w-5 md:h-6 md:w-6"
                                    />
                                    <span className="text-lg md:text-xl text-olm-new-black/90">
                                        {item}
                                    </span>
                                </li>
                            ))}
                        </ul>

                        {/* Right: Image collage */}
                        {/* <div className="grid grid-cols-2 grid-rows-2 gap-5 md:gap-7 items-center">
                            <div className="col-span-1 row-span-2 rounded-[64px] overflow-hidden bg-olm/20 aspect-[3/4] md:aspect-[3/4]">
                                <div className="h-full w-full bg-olm flex">
                                    <img
                                        src="/assets/homepage/man-with-phone.png"
                                        alt=""
                                        className="h-full w-full object-cover"
                                    />
                                </div>
                            </div>
                            <div className="rounded-[64px] overflow-hidden bg-secondary/90 aspect-square">
                                <img
                                    src="/assets/homepage/jenn-brown.png"
                                    alt=""
                                    className="h-full w-full object-cover"
                                />
                            </div>
                            <div className="rounded-[64px] overflow-hidden bg-olm-yellow aspect-square">
                                <img
                                    src="/assets/homepage/jake-soper.png"
                                    alt=""
                                    className="h-full w-full object-cover"
                                />
                            </div>
                        </div> */}
                        <div>
                            <img
                                src="/assets/better-direct-mail/olm-edge-hero-1.webp"
                                alt=""
                                className="w-full "
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
